// Gates the Yuno v2 checkout mechanism for ALL product types (content,
// programas, talleres). It is intentionally product-agnostic: talleres ride the
// same flag as programas/content because the flag reflects "Yuno v2 checkout is
// live", not a per-product rollout. The talleres post-payment cohort enrollment
// bridge is wired on the backend, so no separate taller flag is needed.
export const checkoutV2YunoFeatureFlag = "checkout-v2-yuno";
